module.exports = __webpack_public_path__ + "img/00003.c43efd11.webp";